'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

function _interopNamespace(e) {
    if (e && e.__esModule) { return e; } else {
        var n = {};
        if (e) {
            Object.keys(e).forEach(function (k) {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            });
        }
        n['default'] = e;
        return n;
    }
}

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var LoaderContent = require('../../01.atoms/LoaderContent/LoaderContent.js');
var dynamic = require('../../../utils/dynamic/dynamic.js');
require('./_index.scss.js');

var _excluded = ["children", "className"];
var Swiper = dynamic(function () {
  return new Promise(function (resolve) { resolve(_interopNamespace(require('react-id-swiper'))); });
}, {
  loading: function loading() {
    return /*#__PURE__*/React__default.createElement(LoaderContent, {
      contentPlaceholder: true,
      delay: 0
    });
  }
});
var CLASSNAME = 'varta-swiper',
    cnPagination = "".concat(CLASSNAME, "__pagination"),
    cnBullet = "".concat(CLASSNAME, "__bullet"),
    cnBulletActive = "".concat(cnBullet, "--active");
var PARAMS = {
  modules: [],
  pagination: {
    el: ".".concat(cnPagination),
    clickable: true,
    bulletClass: cnBullet,
    bulletActiveClass: cnBulletActive
  },
  containerClass: "".concat(CLASSNAME, "__container"),
  wrapperClass: "".concat(CLASSNAME, "__wrapper"),
  slideClass: "".concat(CLASSNAME, "__slide")
};
/**
 * 
 */

var SwiperEl = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(SwiperEl, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(SwiperEl);

  function SwiperEl() {
    _rollupPluginBabelHelpers.classCallCheck(this, SwiperEl);

    return _super.apply(this, arguments);
  }

  _rollupPluginBabelHelpers.createClass(SwiperEl, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          props = _rollupPluginBabelHelpers.objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(React.Suspense, {
        fallback: /*#__PURE__*/React__default.createElement(LoaderContent, null)
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames(CLASSNAME, className)
      }, /*#__PURE__*/React__default.createElement(Swiper, _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, PARAMS), props), children))));
    }
  }]);

  return SwiperEl;
}(React__default.Component);
Swiper.propTypes = {
  /** Child nodes */
  children: PropTypes.node,

  /** Additional class name */
  className: PropTypes.string
};

module.exports = SwiperEl;
